import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

function send(eventName, params = {}) {
    if (!analytics) return;

    logEvent(analytics, eventName, params);
}

// General
export function trackPage(page) {
    send("page_view", {
        page_name: page,
    });
}

// Activities
export function trackActivityStarted(activityId) {
    send("activity_started", {
        activity_id: activityId,
    });
}

export function trackActivityCompleted(activityId, score = null) {
    const params = { activity_id: activityId };

    if (score !== null) {
        params.score = score;
    }

    send("activity_completed", params);
}

// Journal
export function trackJournalGenerated() {
    send("journal_generated");
}

// AI
export function trackReflectionGenerated(activityId) {
    send("reflection_generated", {
        activity_id: activityId,
    });
}

// Premium
export function trackPremiumClicked() {
    send("premium_clicked");
}

export function trackAccountCreated(method) {
    send("account_created", {
        signup_method: method,
    });
}